export const systemColors = {
  "sys-blue": {
    100: "#E8F0F6",
    300: "#B3DEF3",
    600: "#45AFE2",
    800: "#155377",
  },
  "sys-chartreuse": {
    25: "#D5E7091A",
    50: "#FDFEF3",
    100: "#F9FBDA",
    200: "#F5F9C2",
    300: "#ECF490",
    400: "#E4EF5F",
    600: "#D5E709",
    700: "#C4D508",
  },
  "sys-green": {
    100: "#ECF7F0",
    300: "#B2E0C3",
    600: "#3EB16A",
    700: "#256C41",
    800: "#256C41",
  },
  "sys-red": {
    100: "#FFE6E6",
    300: "#F2542D",
    600: "#FF0000",
  },
  "sys-neutral": {
    50: "#FFFFFF",
    100: "#FCFCFA",
    200: "#F8F8F4",
    300: "#F6F7EE",
    400: "#F3F4E9",
    500: "#F1F2E6",
    600: "#EEEFE4",
  },
  "sys-lavender": {
    100: "#DEDCF3",
    300: "#A9A1E6",
    800: "#473D80",
  },
  "sys-pink": {
    100: "#FBEAFD",
    600: "#EA8BED",
    800: "#832581",
  },
  "sys-grey": {
    50: "#E2E2E2",
    200: "#C8C7C7",
    400: "#A3A1A1",
    500: "#888888",
    600: "#565353",
    700: "#4B4748",
  },
  "sys-black": {
    DEFAULT: "#000000",
    50: "#F4F4F4",
    100: "#DEDDDE",
    200: "#C8C7C7",
    300: "#9C9A9B",
    400: "#706D6E",
    500: "#323132",
    850: "#231F20",
    900: "#090C08",
    1000: "#000000",
  },
  "sys-coral": {
    100: "#FFE6E6",
    300: "#F2542D",
    800: "#843118",
  },
  "sys-olive": {
    100: "#D5E0C9",
    300: "#B3D191",
    800: "#334B1C",
  },
  "sys-marmalade": {
    100: "#FFE3BF",
    300: "#F1A300",
    800: "#491F01",
  },
  "sys-opacity-light": {
    5: "#FFFFFFF2",
    10: "#FFFFFFE6",
    20: "#FFFFFFCC",
    30: "#FFFFFFB3",
    40: "#FFFFFF99",
    50: "#FFFFFF80",
    60: "#FFFFFF66",
    70: "#FFFFFF4D",
    80: "#FFFFFF33",
    90: "#FFFFFF1A",
    95: "#FFFFFF0D",
  },
  "sys-opacity-dark": {
    5: "#000000F2",
    10: "#000000E6",
    20: "#000000CC",
    30: "#000000B3",
    40: "#00000099",
    50: "#00000080",
    60: "#00000066",
    70: "#0000004D",
    80: "#00000033",
    90: "#0000001A",
    95: "#0000000D",
  },
  "sys-outline": {
    dark: "#0000001A",
    light: "#FFFFFF4D",
  },
  "sys-transparent": "transparent",
  "sys-white": "#ffffff",
};
